import { ERROR_CODES } from '@/shared/constants/errors.js'
import OperationController from '../domain/controller.js'
import { EVENTS } from '@/shared/constants/commons.js'

async function triggerAction(dataKey, payload, context, method = 'post') {
  const { events, networkRepo, sendBugAlert } = context

  console.log("🚀 ~ triggerAction ~ payload:", payload)
  if (!payload.ignoreLoading) events.dispatch(EVENTS.APPLICATION_IS_WORKING)
  delete payload.ignoreLoading

  let res = null

  try {
    res = await OperationController.triggerAction(
      dataKey,
      payload,
      networkRepo,
      method,
    )
  } catch (error) {
    console.log('🚀 ~ triggerAction ~ error:', error)

    let title = ''
    let body = ''

    switch (error?.code) {
      case ERROR_CODES.SERVICE_UNAVAILABLE:
        title = 'Service temporarily unavailable'
        body =
          'The validation service is not available at the moment. Please try again in a few moments.'
        break

      case ERROR_CODES.CONFLICT:
        title = 'Operation already validated'
        body =
          'This operation has already been validated or is being processed. Check your previous actions.'
        break

      case ERROR_CODES.SERVER_ERROR:
      default:
        title = 'Technical error'
        body =
          "Nous vérifions s'il y a un problème avec votre compte. Veuillez réessayer ou contacter le support."
        sendBugAlert(error)
        break
    }

    events.dispatch(EVENTS.TOAST_NOTIFICATION_REQUESTED, {
      title,
      body,
      type: 'error',
    })
  }

  await new Promise(r => {
    setTimeout(r, 250)
  })

  events.dispatch(EVENTS.APPLICATION_WORK_FINISHED)
  await new Promise(r => {
    setTimeout(r, 250)
  })

  return res
}

export default triggerAction
